import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { API_GENERATE_INVESTMENT_STATEMENT } from "../../../config/api";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";

export const generateInvestmentStatement = createAsyncThunk(
  "user/generateInvestmentStatement",
  async ({ data, callback, failed }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_GENERATE_INVESTMENT_STATEMENT,
        queryParams: {
          user_id: data?.user_id,
          currency: data?.currency,
          date_from: data?.date_from,
          date_to: data?.date_to,
          email: data?.email,
          download_only: data?.download_only,
          send_to_user: data?.send_to_user,
        },
      });

      toast.success(
        data?.download_only
          ? "Investment statement is being generated for download."
          : "Investment statement is being generated and will be sent to the user's email shortly.",
      );
      callback && callback(response?.data);

      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed && failed();
      return rejectWithValue(error.message);
    }
  },
);
